import { render, staticRenderFns } from "./dashboardView.vue?vue&type=template&id=b3817c96&scoped=true&"
import script from "./dashboardView.vue?vue&type=script&lang=js&"
export * from "./dashboardView.vue?vue&type=script&lang=js&"
import style0 from "./dashboardView.vue?vue&type=style&index=0&id=b3817c96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3817c96",
  null
  
)

export default component.exports